import request from '@/utils/request'

export function login (params) {
  return request({
    method: 'post',
    withCredentials: true,
    data: {
      do: 'login',
      ...params
    }
  })
}

// 实名认证
export function verified (params) {
  return request({
    method: 'post',
    data: {
      do: 'verified',
      ...params
    }
  })
}

// 账号升级
export function accountUp (params) {
  return request({
    method: 'post',
    data: {
      do: 'accountUp',
      ...params
    }
  })
}

export function logout () {
  return request({
    method: 'get',
    params: {
      do: 'logout'
    }
  })
}
